// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem-module--menuItem--gmcZf","label":"MenuItem-module--label--3nkwd","labelWithPrefixIcon":"MenuItem-module--labelWithPrefixIcon--23V0l"};